import { Component, EventEmitter, Input, Output } from "@angular/core";
import { CommonModule } from "@angular/common";
import { PaginationComponent } from "../../../pagination/pagination.component";
import { PaginationState } from "../../../../models/pagination";
import { FilterItem, TableRow } from "../../../../models/common-table";
import { GroupByPayload } from "../../../../models/vcloud-api";

@Component({
  selector: "app-common-table-footer",
  standalone: true,
  imports: [CommonModule, PaginationComponent],
  templateUrl: "./common-table-footer.component.html",
})
export class CommonTableFooterComponent {
  @Input() loading = false;
  @Input() showPagination = true;
  @Input() pageNumber = 0;
  @Input() disabled = false;
  @Input() dynamicPagination = false;
  @Input() exactRows: number | undefined;
  @Input() pageSize = 10;
  @Input() tableRows: TableRow[] = [];
  @Input() totalRowsPayload?: { RequestBody: GroupByPayload; Attribute: string; Filters: FilterItem[] };

  @Output() pageChanged = new EventEmitter<PaginationState<TableRow>>();

  private lastPaginationState = "";

  public handlePageChanged(newPageState: PaginationState<TableRow>): void {
    const currentState: string = JSON.stringify({
      pageNumber: newPageState.pageNumber,
      pageSize: newPageState.pageSize,
      currentPageLength: newPageState.currentPage?.length ?? 0,
    });

    if (this.lastPaginationState === currentState) {
      return;
    }

    this.lastPaginationState = currentState;
    this.pageChanged.emit(newPageState);
  }
}
